module.exports = __webpack_public_path__ + "img/cardBack.cd091f35.jpg";